import React, { useMemo } from 'react';
import { Result } from '@whalecloud/fdx';
import KeepAlive from 'react-activation';

const TagProvider = props => {
  const { tabKey, parentTabKey } = props;
  const value = useMemo(() => { // eslint-disable-line
    return {
      tabKey,
      parentTabKey,
    };
  }, [tabKey, parentTabKey]);
  return <TagNavContext.Provider value={value}>{props.children}</TagNavContext.Provider>;
};
const TagNavContext = React.createContext({
  tabKey: undefined,
  parentTabKey: undefined,
});

export default function withTabView(WrappedComponent) {
  const MyComponent = WrappedComponent;
  return props => {
    const { tabKey: key, parentTabKey } = props.location.state || {};
    const tabKey = key || props.location.pathname;
    if (!tabKey) {
      return null;
    }
    const when = true;
    return (
      <KeepAlive name={tabKey} id={tabKey} when={when}>
        <TagProvider tabKey={tabKey} parentTabKey={parentTabKey}>
          {/* 包裹开始 */}
          <ExceptionView>
            <MyComponent {...props} />
          </ExceptionView>
          {/* 包裹结束 */}
        </TagProvider>
      </KeepAlive>
    );
  };
}

class ExceptionView extends React.Component {
  state = { error: false };

  componentDidCatch(error, info) {
    // console.error(error);
    this.setState({ error, info }); // eslint-disable-line
  }

  render() {
    if (this.state.error) {
      return (
        <Result
          status="error"
          title="error"
          subTitle="An error occured, please contact the administrator"
          // extra={<Button type="primary">Back Home</Button>}
        />
      );
    }
    return this.props.children;
  }
}
